import { buildQuickview } from "@coveo/headless";
import React, { FunctionComponent, MouseEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import Modal from './Modal';
import SelectBtn from "./SelectBtn";

const DownloadBtn: FunctionComponent<any> = ({item, disabled}) => {
    const [showModal, setShowModal] = useState(false);
    const [contentInstruction, setContentInstruction] = useState('');
    let renditionUrl = "https://www.usa.canon.com/nw3s" + item.rendition_url;
    let fileId = item.inetdoccid;
    let searchResultDownloadFile = JSON.parse(localStorage.getItem("searchResultDownloadFile") || '""') || {};
    let statusDownload = searchResultDownloadFile[fileId]?.statusDownload || {};
    const [status, setStatus] = useState(statusDownload.status || "");
    const [percent, setPercent] = useState(statusDownload.percent || "0%");
    const downloadBtnLabel = {
        "starting": "STARTING...",
        "downloading": "DOWNLOADING",
        "complete": "COMPLETE",
    }
    const handleClick = async (e: any) => {
        e.preventDefault();
        if (downloadBtnLabel[status as keyof typeof downloadBtnLabel]) {
            return;
        }
        download(e.currentTarget);
    }

    const updateStatus = (fileId: string, statusDownload: { status: string, percent: string }):void => {
        let searchResultDownloadFile = JSON.parse(localStorage.getItem("searchResultDownloadFile") || '""') || {};
        searchResultDownloadFile[fileId] = {statusDownload};
        localStorage.setItem("searchResultDownloadFile", JSON.stringify(searchResultDownloadFile));
        setStatus(statusDownload.status);
        if (statusDownload.percent) {
            setPercent(statusDownload.percent);
        }
    }
    const download = async function (element: any) {
        let fileId = element.getAttribute("file-id");
        updateStatus(fileId, {status:"starting", percent: "0%"});
        let contentLength = 0;
        var fileInfo = element.closest(".content").querySelector(".fileSize").lastChild.innerHTML.split(" ");
        if (fileInfo[1].toLowerCase() === "gb") {
            contentLength = Math.round(fileInfo[0] * 1024);
        } else if (fileInfo[1].toLowerCase() === "mb") {
            contentLength = Math.round(fileInfo[0]);
        } else if (fileInfo[1].toLowerCase() === "kb") {
            contentLength = Math.round(fileInfo[0] / 1024);
        }

        const DOWNLOAD_SPEED = 24;
        let percent = 0;
        const downloadInterval = setInterval(() => {
            percent += (DOWNLOAD_SPEED / contentLength) * 100;
            if (percent >= 100) {
               updateStatus(fileId,{status:"complete", percent: "100%"});
               clearInterval(downloadInterval);
               return;
            }
            updateStatus(fileId,{status:"downloading", percent: percent + "%"});
        }, 1000);

        window.open(element.href.replace("http:", "https:"), "_self");
    }
    const _getCurrentBrower = function() {
        const userAgent = navigator.userAgent;
        let browserName = '';

        if (navigator.userAgent.search("Edg") <= -1) {
            //Check if browser is IE
            if (
                navigator.userAgent.indexOf("MSIE") != -1 ||
                // @ts-ignore
                !!document.documentMode == true
            ) {
                browserName = 'ie';
            }
            //Check if browser is Chrome
            else if (navigator.userAgent.search("Chrome") >= 0) {
                browserName = 'chrome';
            }
            //Check if browser is Firefox
            else if (navigator.userAgent.search("Firefox") >= 0) {
                browserName = 'firefox';
            }
            //Check if browser is Safari
            else if (
                navigator.userAgent.search("Safari") >= 0 &&
                navigator.userAgent.search("Chrome") < 0
            ) {
                browserName = 'safari';
            }
        }
        //Check if browser is Edge
        else if (navigator.userAgent.search("Edg") > 0) {
            browserName = 'edge';
        }
        else {
            browserName = 'default';
        }

        return browserName;
    }
    const showInstruction = async () => {

        try {
            let wrapperElm = document.createElement("div");
            // TODO: remove data_mock : currently it is webtest
            const domain = window.location.hostname === "localhost" ? "https://www.webtest.usa.canon.com" : window.location.origin;
            const response = await axios.get(`${domain}/content/experience-fragments/canonxf/instructional_copy/${_getCurrentBrower()}-experience-fragment/master.html`).then(res => {
                wrapperElm.innerHTML = res.data;
                setContentInstruction(wrapperElm.querySelector(".aem-container")!.innerHTML);
            });
        } catch (error) {
            console.error('Error fetching content:', error);
        }
    };
    const handleClickInstructionBtn = (e: MouseEvent) => {
        e.preventDefault();
        setShowModal(true);
        if (!contentInstruction) {
            showInstruction();
        }
    }
    const linkDownload = item.ineturl?.replace("http://", "https://");
    var checkboxClass: string = 'btn btn-primary btn-common outlined-button cta-active my-modal-button ada-clickable' + (disabled ? ' disabled' : '');
    return (<div className="cardButton rightSection" >
        <div className={"cta-container " + status}>
            <div className="download__cta">
                <div className="cta-btn-container">
                    <div className="outlined-btn-wrapper" data-target="#instructionalXFModal">
                        <a role="button" target="_blank" {...{"file-id": item.inetdoccid}} onClick={handleClick} href={linkDownload ?? '#'} className={checkboxClass}>
                            <div className="prepare-download">
                                <div className="prepare-download__spinner">
                                    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                                </div>
                            </div>
                            <span className="icon-download-success"></span>
                            <span>{downloadBtnLabel[status as keyof typeof downloadBtnLabel] ?? "DOWNLOAD"}</span>
                            <span className="download-icon"></span>
                        </a>
                        <div className="download-progress">
                            <div className="download-progress__bar" style={{width: percent}}></div>
                        </div>
                    </div>
                    <div className="outlined-btn-wrapper-mobile" data-target="#instructionalXFModal">
                        <a role="button" href={linkDownload} target="_blank" className="my-modal-button download-icon"></a>
                    </div>
                    {status === "complete" && <a href="#" className="instructional-button" onClick={handleClickInstructionBtn}>Next: How to locate and install your download</a>}
                    {showModal && <Modal showButtonClose={true} visible={true} stateChange={setShowModal} htmlContent={contentInstruction} headerContent={'Locating and installing your download'}></Modal>}
                </div>
            </div>
        </div>

    </div>);
}
export default DownloadBtn;